<script>
export default {
  data () {
    return {
      oscillateOption: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 40
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: [128, 256, 384, 512, 640, 768]
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            // formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00]
        }, {
          name: 'Ub',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00]
        }, {
          name: 'Uc',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00]
        }
        ]
      },
      oscillateChart: {},
      // 电气量下拉框
      oscillateCountSelectOptions: [{
        value: 1,
        label: '记录1'
      }, {
        value: 2,
        label: '记录2'
      }, {
        value: 3,
        label: '记录3'
      }, {
        value: 4,
        label: '记录4'
      }, {
        value: 5,
        label: '记录5'
      }, {
        value: 6,
        label: '记录6'
      }, {
        value: 7,
        label: '记录7'
      }, {
        value: 8,
        label: '记录8'
      }, {
        value: 9,
        label: '记录9'
      }, {
        value: 10,
        label: '记录10'
      }, {
        value: 11,
        label: '记录11'
      }, {
        value: 12,
        label: '记录12'
      }, {
        value: 13,
        label: '记录13'
      }, {
        value: 14,
        label: '记录14'
      }, {
        value: 15,
        label: '记录15'
      }],
      oscillateCountSelectValue: 1
    }
  },
  mounted () {
    this.oscillateChart = this.$echarts.init(document.getElementById('oscillateOptions'))
    this.oscillateChart.setOption(this.oscillateOption)
  },
  methods: {}
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">振荡波形记录</div>

      <div style="width: 100%; display: flex;">
        <div
          style="width: 250px; display: flex; align-items: center; margin-left: 20px; justify-content: space-around">
          <div>暂降记录</div>
          <div style="width: 150px">
            <el-select v-model="oscillateCountSelectValue" placeholder="请选择">
              <el-option
                v-for="item in oscillateCountSelectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div style="height: calc(100% - 70px);">
        <div id="oscillateOptions" style="height: 100%; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/transient.css";

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Transient/OscillateChart/OscillateChart.vue